module.exports = __webpack_public_path__ + "static/img/shebei.0cee9b6.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/shebei.png
// module id = MmrC
// module chunks = 2